import router from './router'
import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, setToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/forgot-pass', '/confirm-forgot-pass', '/create-pass', /^\/siteresponse\/.*/ ] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  if (to.path === '/logout') {
    await store.dispatch('user/logout')
    NProgress.done()
    next({ path: '/login' })
    return
  }

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    setToken(hasToken)
    if (to.path === '/login') {
      if (store.getters.role !== 'Storage') {
        // if is logged in, redirect to the home page
        next({ path: '/' })
      } else {
        await store.dispatch('user/resetToken')
        next()
      }
      NProgress.done()
    } else {
      const hasGetUserInfo = store.getters.name
      if (hasGetUserInfo) {

        if (store.getters.role === 'Storage' && !/^\/siteresponse\/.*/.test(to.path)) {
          await store.dispatch('user/resetToken')
          next('/login')
        }

        next()
      } else {
        try {
          // get user info
          await store.dispatch('user/getInfo')

          if (store.getters.role === 'Storage' && !/^\/siteresponse\/.*/.test(to.path)) {
            await store.dispatch('user/resetToken')
            next('/login')
          }
    
          next()
        } catch (error) {
          // remove token and go to login page to re-login
          // await store.dispatch('user/resetToken')
          // Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token */
    // check vs whitelist
    if (whiteList.find(path => {
      if (path === to.path) return true
      if (path.test && path.test(to.path)) return true

      return false
    })) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
